/**
 * Created by jpilz on 2/13/17.
 */
import ko from 'knockout';
import axios from 'axios';

class utilObj {

  constructor() {
    this.log();
    this.name = "utilObj";
    this.debug = false;
  }

  scrollToTop(modal) {

    console.log('utils:scrollToTop:  modal: %o', modal);
    parent.scrollTo(0, 0);
  }


  log(obj) {
    if (this.debug) {
      console.log(this.componentname + ":");
      console.log(obj);
    }
  }

  guid() {

    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }


  tryParseJSON(jsonString) {
    try {
      var o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object", 
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === "object") {
        return o;
      }
    } catch (e) {
      console.log(e)
    }

    return false;
  }


  tryAPIAutoLogin(context) {

    let self = this;

    //this.apiAccessToken(context.readCookie('access_token'));
    //this.apiUserID(context.readCookie('access_id'));

    let callData = JSON.stringify({});
    let url = context.generateApiUrl('/Users/' + context.apiUserID);

    axios({
      url: url,
      method: 'get',
      headers: context.apiContentType,
      data: callData
    }).then((response) => {
      //this.log(response.data);
      this.handleApiLoginAttempt(context, response);
      //context.eventManager.notifySubscribers(context.loginStatusObj(),"loginStatus");
    }).catch((error) => {
      console.log("tryLogin Error:");
      console.log(error);
      console.log(error.response);

      if (typeof error.response !== undefined) {

        //alert('Error connscting to API');

      }

    });

  }

  apiLogin(context) {

    let self = this;
    let url = context.apiEntryPointUrl + '/Users/login';

    console.log("utils:apiLogin: url:%s", url);
    //console.table(context,["index","Value","name","_latestValue"]);

    let callData = JSON.stringify({
      "username": context.apiUserName,
      "password": context.apiAppId
    });

    axios({
      url: url,
      method: 'post',
      headers: context.apiContentType,
      data: callData
    }).then((response) => {
      console.log(response.data);
      this.handleApiLoginAttempt(context, response);
    }).catch((error) => {
      console.log("tryLogin Error:");
      console.log(error);
      console.log(error.response);

      if (typeof error.response !== undefined) {
        //alert('Error connscting to API');
      }

      //this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting for Template Widget"},"messageModel");
    });

  }

  handleApiLoginAttempt(context, response) {
    console.log("handle API Login Attempt");
    console.log(response);

    if (typeof response.status !== undefined) {
      if ((response.status === 200) && (response.data.id.length > 63)) {
        console.log("Utils:handleApiLoginAttempt: login");
        context.apiUserID = response.data.userId;
        context.apiAccessToken = response.data.id;
        context.createCookie('access_token', response.data.id, 1);
        context.createCookie('access_id', response.data.userId, 1);

        console.debug("Utils:handleApiLoginAttempt: Sending API Login");
        //context.loginStatusObj().CookieCheck = true;
        //context.loginStatusObj().API = true;
        console.log("Utils:handleApiLoginAttempt:handleApiLoginAttempt:");
        console.log(context.loginStatusObj());
        context.loginStatusObj.valueHasMutated();
        //context.eventManager.notifySubscribers(context.loginStatusObj(),"loginStatus");
        return true;
      } else {
        console.log("utils:handleApiLoginAttempt:log failed - Inside response")
        console.log(response.data.id.length);
        return false;
      }
    } else {
      console.log("utils:handleApiLoginAttempt:log failed");
      return false;
    }

  }

  cleanJavascriptTime(time) {
    console.log("apiTokenUtil:cleanJavascriptTime time: %o", time)
    var datetime = new Date(time);
    return datetime.toISOString().replace('Z', '').replace('T', ' ')
  }

  cleanJavascriptDate(time) {
    console.log("apiTokenUtil:cleanJavascriptDate time: %o", time)
    var datetime = new Date(time)
    console.log("apiTokenUtil:cleanJavascriptDate time: %o", time)
    return datetime.toISOString().replace('Z', '').replace('T', ' ').substring(0, 10)
  }

  basicDate() {
    var datetime = new Date()
    return datetime.toISOString().replace('Z', '').replace('T', ' ').substring(0, 10)
  }

}


export default new utilObj();


// WEBPACK FOOTER //
// ./src/objects/utils.js